/* eslint-disable no-empty-pattern */
/* eslint-disable no-shadow */
import SelectedTimeSlot from '@/models/date-picker/SelectedTimeSlot';
import ExtraData from '@/models/ExtraData';
import IAvailabilityData from '@/models/test-drive/interfaces/availability-data.d';
import IVehicle from '@/models/vehicle/interfaces/vehicle.d';
import {
  GetterTree, MutationTree, ActionTree, Module
} from 'vuex';
import IRootState from '../states/interfaces/index.d';
import ITestDriveAvailabilityState from '../states/interfaces/test-drive-availability-state.d';
import TestDriveAvailabilityState from '../states/test-drive-availability-state';

export const state: ITestDriveAvailabilityState = new TestDriveAvailabilityState();

export const getters: GetterTree<ITestDriveAvailabilityState, IRootState> = {
  retailerAvailability: (state): IAvailabilityData[] => {
    if (state.retailerAvailability !== null) {
      return state.retailerAvailability;
    }

    return [];
  },
  appointment: (state): SelectedTimeSlot | null => state.selectedAvailability,
  allowedManufacturerIds: (state, getters, rootState): number[] => {
    const ids = rootState.initialSettingsModule.initialSettings.allowedTestDriveManufacturerIds;

    if (!ids) {
      return [];
    }

    return ids;
  },
  blockedRangeIds: (state, getters, rootState): number[] => {
    const ids = rootState.initialSettingsModule.initialSettings.blockedTestDriveRangeIds;

    if (!ids) {
      return [];
    }

    return ids;
  },
  noResults: (state): boolean => state.noResults,
  isValidTestDriveSlot: (state, getters, rootState, rootGetters): boolean => {
    if (rootState.enquiryModule.enquiry.testDriveRequested === false) {
      return true;
    }

    const vehicle: IVehicle | null = rootGetters['vehicleModule/currentVehicle'];

    if (vehicle === null
      || vehicle.manufacturerId !== 7
      || getters.blockedRangeIds.includes(vehicle.rangeId)
      || state.noResults) {
      return true;
    }

    return state.selectedAvailability !== null
      && state.selectedAvailability.id > 0
      && rootState.enquiryModule.enquiry.testDriveRequested;
  }
};

export const mutations: MutationTree<ITestDriveAvailabilityState> = {
  setRetailerAvailability: (state: ITestDriveAvailabilityState, retailerAvailability: IAvailabilityData[]) => {
    state.retailerAvailability = retailerAvailability;
  },
  setAppointment: (state: ITestDriveAvailabilityState, appointment: SelectedTimeSlot | null) => {
    state.selectedAvailability = appointment;
  },
  setNoResults: (state: ITestDriveAvailabilityState, noResults: boolean) => {
    state.noResults = noResults;
  }
};

export const actions: ActionTree<ITestDriveAvailabilityState, IRootState> = {
  async submitRetrieveRetailerAvailability({
    commit, dispatch, getters, state, rootState, rootGetters
  }) {
    const vehicle: IVehicle | null = rootGetters['vehicleModule/currentVehicle'];
    const allowedManufacturerIds = rootGetters['testDriveAvailabilityModule/allowedManufacturerIds'];

    if (!vehicle
      || !allowedManufacturerIds
      || !allowedManufacturerIds.includes(vehicle.manufacturerId)
      || rootState.addressModule.address.latitude === 0
      || rootState.addressModule.address.longitude === 0
      || getters.blockedRangeIds.includes(vehicle.rangeId)) {
      dispatch('submitResetSelection');
      return;
    }

    const { selectedRetailer } = rootState.retailerModule;

    if (selectedRetailer
      && selectedRetailer.retailerId > 0) {
      commit('setNoResults', false);
      dispatch('submitResetSelection');
      commit('setRetailerAvailability', selectedRetailer.availability);
    } else {
      commit('setNoResults', true);
      commit('setRetailerAvailability', []);
      dispatch('submitResetSelection');
    }
  },
  submitAppointment({ commit, dispatch }, slot: SelectedTimeSlot | null) {
    commit('setAppointment', slot);

    if (slot) {
      dispatch('enquiryModule/submitExtraData', new ExtraData('RetailerAppointmentDateTime', `${slot.start.toISOString()}`), { root: true });
      dispatch('enquiryModule/submitExtraData', new ExtraData('RetailerAppointmentDateFormatted', slot.dateFormatted), { root: true });
      dispatch('enquiryModule/submitExtraData', new ExtraData('RetailerAppointmentStartTimeFormatted', slot.startTimeFormatted), { root: true });
      dispatch('enquiryModule/submitExtraData', new ExtraData('RetailerAppointmentEndTimeFormatted', slot.endTimeFormatted), { root: true });
      dispatch('enquiryModule/submitExtraData', new ExtraData('RetailerAppointmentStartEndFormatted', slot.startEndTimeFormatted), { root: true });
    } else {
      dispatch('enquiryModule/submitRemoveExtraData', 'RetailerAppointmentDate', { root: true });
      dispatch('enquiryModule/submitRemoveExtraData', 'RetailerAppointmentDateFormatted', { root: true });
      dispatch('enquiryModule/submitRemoveExtraData', 'RetailerAppointmentStartTimeFormatted', { root: true });
      dispatch('enquiryModule/submitRemoveExtraData', 'RetailerAppointmentEndTimeFormatted', { root: true });
      dispatch('enquiryModule/submitRemoveExtraData', 'RetailerAppointmentStartEndFormatted', { root: true });
    }
  },
  submitResetSelection({ dispatch }) {
    dispatch('submitAppointment', null);
  }
};

export const testDriveAvailabilityModule: Module<ITestDriveAvailabilityState, IRootState> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
